<template>
<div class="helping-hand">
  <div v-wechat-title="$tm('index2024.award.title')" />
  <!-- <GcSkeleton :is-show="isLoading" /> -->
  <GCLOADING :is-show="data.isLoading" />
  <GCHeaderRank v-if="data.tipShow" :webapp-link="data.routerLink" />
  <!-- <GCGUIDE :down-show="data.isWeiXin" @showDwon="getWechat" /> -->
  <ShareInfo :share-info="shareData" />

  <!-- 背景信息 -->
  <div class="user-info">
    <div class="info">
      <div class="user-avatar">
        <img class="avatar" :src="data.userInfo.headImgUrl" alt="">
        <div>
          <div class="name">{{ data.userInfo.nickname }}</div>
          <div class="job">{{ data.userInfo.dutyname }}</div>
        </div>
      </div>
      <div :class="`invite_btn ${isActiveEnd ? 'disabled' : ''}`" @click="goToInvite">{{ $tm('index2024.award.invite_btn') }}</div>
    </div>

    <div class="values">
      <div><span class="label">{{ $tm('index2024.award.help_title') }}</span> <span class="value ft_bm">{{ data.userInfo.total_score }}</span></div>
      <div><span class="label">{{ $tm('index2024.award.source_title') }}</span> <span class="value ft_bm">{{ data.userInfo.today_score }}</span></div>
    </div>

    <div class="rule">
      {{ $tm('index2024.award.activeRule') }}
      <span class="rule-text" @click="">
        <!-- 规则 -->
        <Rule :is-round="false" type="home" />
      </span>
    </div>

    <div class="award-gain" v-if="data.userInfo.qualified.show">
      <div>
        <div>🎉恭喜你！获得：</div>
        <div class="award-ranking">助力之星第 <span class="ft_bm">{{ data.userInfo.qualified.rank }}</span> 名</div>
      </div>
      <div class="prize" @click="goToPrize">
        领取奖品
        <van-icon name="arrow" />
      </div>
    </div>
  </div>

  <!-- 助力内容 -->
  <div class="helping-content">
    <van-tabs v-model:active="active">
      <van-tab :title="$tm(`index2024.award.tabs`)[0]"></van-tab>
      <van-tab :title="$tm(`index2024.award.tabs`)[1]"></van-tab>
    </van-tabs>

    <!-- 助力任务 -->
    <div class="helping-task" v-show="active === 0">
      <div class="task-list" v-for="(item, idx) in taskList" :key="idx">
        <div>
          <div class="task_name">{{ item.taskName }} <span class="ft_bm">+{{ item.source }}</span></div>
          <div class="explain">{{ item.explain }}</div>
        </div>
        <div v-if="isActiveEnd" class="task_btn is-gray">已结束</div>
        <div v-else :class="['task_btn', [3, 4].includes(+item.status) ? 'is-gray' : '']" @click="goToComplete(item)">{{ item.btnText }}</div>
      </div>
    </div>

    <!-- 助力排行榜 -->
    <div class="rank-list" v-show="active === 1">
      <div class="header">
        <div class="header-item">{{ $tm(`index2024.award.rankHeader`)[0] }}</div>
        <div class="header-item">{{ $tm(`index2024.award.rankHeader`)[1] }}</div>
        <div class="header-item">{{ $tm(`index2024.award.rankHeader`)[2] }}</div>
      </div>
      <van-pull-refresh v-model="refreshing">
        <van-list
          v-model:loading="isLoading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="body" v-if="rankList.length">
            <div class="body-item" v-for="(item, idx) in rankList" :key="idx">
              <div class="rank-index ft_bm" :class="`rank_${idx + 1}`">{{ idx + 1 }}</div>
              <div class="user-id">
                <img class="user-avatar" :src="item.usr_pic" :alt="item.nick_name">
                <span>{{ item.nick_name }}</span>
              </div>
              <div class="help-value ft_bm">{{ item.score_total }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <!-- <div class="body">
        <div class="body-item" v-for="(item, idx) in rankList" :key="idx">
          <div class="rank-index ft_bm" :class="`rank_${idx + 1}`">{{ idx + 1 }}</div>
          <div class="user-id">
            <img class="user-avatar" :src="item.usr_pic" :alt="item.nick_name">
            <span>{{ item.nick_name }}</span>
          </div>
          <div class="help-value ft_bm">{{ item.score_total }}</div>
        </div>
      </div> -->
    </div>
  </div>

</div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant'
import { useThrottleFn } from '@vueuse/core'
import utils from '@/utils/utils'
import { platformType, getAuth } from '@/utils/index'
import { ajaxHttp } from '@/api/api'
import i18n from '@/languages'
import config from '@/config/config'

import GCLOADING from '@/components/gc-loading'
import GCHeaderRank from '@/components/gc-header-rank'
// import GCGUIDE from '@/components/gc-guide'
import ShareInfo from '@/components/shareInfo'
import Rule from './rule'

const router = useRouter()
const route = useRoute()

const refreshing = ref(false);
const isLoading = ref(false);
const finished = ref(false);

const active = ref(0)
const data = reactive({
  isGteatChefbrowser: utils.isGteatChefbrowser(), // 名厨浏览器
  isMini: utils.is_mini(), // 小程序
  isLoading: false,
  tipShow: true,
  // pathInfo: {},
  routerLink: '/2024mc/index',
  // isWeiXin: false,
  // _uid: '',
  // get uid() {
  //   return this._uid
  // },
  // set uid(value) {
  //   this._uid = value
  // },
  userInfo: {
    headImgUrl: '',
    dutyname: '',
    nickname: '',
    qualified: {}
  }
})
const shareData = ref({
  share_title: i18n.global.tm(`index2024.award`).share_title,
  share_desc: i18n.global.tm(`index2024.award`).share_des,
  share_img: 'https://static.mingchu.co/webapp/index2024/share/index_award.png',
  share_link: location.href
}) // 分享数据

// 任务列表
const taskList = ref([
  {
    taskName: '每日活动签到',
    explain: '每日打开指数页面可获得 3个助力值',
    source: '3',
    status: '3',
    type: 'check_in'
  },
  {
    taskName: '每日活动分享',
    explain: '分享指数页面给好友可获得 5个助力值',
    source: '5',
    status: '0',
    type: 'share'
  },
  {
    taskName: '收藏/关注内容',
    explain: '收藏/关注入围作品、厨师、餐厅、企业等每次可获得 3个助力值',
    source: '3',
    status: '0',
    type: 'follow'
  },
  {
    taskName: '票选阶段投票',
    explain: '票选期间投出 1票可获得 2个助力值，直至票数用完',
    source: '2',
    status: '0',
    type: 'share_vote'
  },
  {
    taskName: '为厨师/餐厅助力',
    explain: '票选期间为榜单中用户、餐厅、分享拉票可每次获得 5个助力值，每日限 10次',
    source: '5',
    status: '0',
    type: 'vote'
  },
  {
    taskName: '邀请成功一位用户',
    explain: '邀请一位用户完成注册，获得 10个助力值次数不限定',
    source: '10',
    status: '0',
    type: 'invitation'
  }
])
const task_status = {
  0: '未开始',
  1: '去完成',
  2: '去分享',
  3: '已结束',
  4: '明日再来'
}
// 排行榜
const rankList = ref([])
const currentPage = ref(1) // 当前分页
const loading = ref(false);
const totalPage = ref(0)

// 活动结束
const isActiveEnd = ref(false)

// 获取 助力排行榜
const getRankList = async () => {
  // if (
  //   // 如果总页数小于等于现页数，并且不是第一次加载， 或者正在加载数据 直接跳出不请求
  //   totalPage.value <= currentPage.value && currentPage.value !== 1
  // ) {
  //   finished.value = true;
  //   return;
  // }
  if (finished.value) {
    return
  }
  
  const res = await ajaxHttp.$get(`/api/ranking2024/supporter_list?page=${currentPage.value}`)

  if (res.code === 1) {
    if (refreshing.value) {
      refreshing.value = false;
    }
    isLoading.value = false;
    let dataReq = res?.data ?? [];

    dataReq = (
      currentPage.value === 1 ? [] : rankList.value
    ).concat(dataReq);
    
    rankList.value = dataReq

    if (res?.data?.length < 19) {
      finished.value = true;
    }
    // totalPage.value = Math.ceil(dataReq.length / 10);
  }
}

// 分享获取积分
const goShare = async () => {
  const link = encodeURIComponent(`${config.webapplink}/2024mc/index`)

  utils.shareWechat(`{
    "shareSDKPlatformType":"22", 
    "share_plant":"2", 
    "shareContentType":"2", 
    "share_miniProgram_url":"pages/redirectUrl/main?urls=${link}", 
    "share_title":"回首2024，展望2025！行业热点已帮你总结好了！",
    "share_desc":"${shareData.value.share_desc}",
    "share_img":"${shareData.value.share_img}", 
    "share_link":"${link}",
    "share_desc_Sinaweibo":""
  }`).then(async (res) => {
    // 埋点
    sensors.track('MCINDEX2024_award_share', {
      MCINDEX_title: 'award',
      from: '2024指数_有奖助力页面_每日活动分享', 
      PlatformType: platformType(),
    })
    await ajaxHttp.$get('/api/ranking2024/share')
    getUserInfo()
    getTaskList()
  })
}

// 获取用户信息
const getUserInfo = async () => {
  const res = await ajaxHttp.$get('/api/ranking2024/supporter')

  if (res.code === 1) {
    const userInfo = {
      headImgUrl: res.data.usr_pic,
      nickname: res.data.nick_name,
      dutyname: res.data.dutyname,
      today_score: res.data.today_score,
      total_score: res.data.total_score,
      qualified: res.data.qualified
    }
  
    data.userInfo = userInfo
  }
}

// const onRefresh = () => {
//   // 重新加载数据
//   console.log("刷新");

//   finished.value = false;
//   // 将 loading 设置为 true，表示处于加载状态
//   isLoading.value = true; // 重点

//   currentPage.value++;
//   getRankList();
// };

const onLoad = () => {
  console.log("触底=====");
  isLoading.value = true; // 重点
  currentPage.value++;
  getRankList();
};

// 获取任务状态
const getTaskList = async () => {
  const res = await ajaxHttp.$get('/api/ranking2024/support_list')

  if (res.code === 1) {
    const taskData = taskList.value
    taskData.forEach((task) => {
      const cur = res.data[task.type]
      if (cur.begin) {
        task.status = ['share'].includes(task.type) ? '2' : '1'
      } else if (cur.end) {
        task.status = '3'
      } else if (cur.done) {
        task.status = '4'
      } else if (['share', 'follow', 'invitation'].includes(task.type)) {
        task.status = (task.type === 'share' ? '2' : '1')
      } else {
        task.status = '0'
      }
      task.btnText = task_status[task.status]
    })

    isActiveEnd.value = res.data.all.end
    taskList.value = taskData
  }
}

// 获取 uid
const getUid = async () => {
  // 获取 app 的 uid
  const USER = await getAuth()
  const { data: { uid } } = JSON.parse(USER)

  data.uid = uid ?? ''
}

// 获取数据
const getData = async () => {
  // data.pathInfo = route.query
  data.routerLink = router.currentRoute.fullPath

  getTaskList()
  getRankList()
  getUserInfo()
  getUid()
  // document.querySelector('.rank-list')?.addEventListener('scroll', handleScroll)
}

// 领取奖品
const goToPrize = () => {
  router.push(`/2024mc/checkForm?leader_type=support`)
}

// 邀请好友参与
const goToInvite = async () => {
  if (isActiveEnd.value) {
    return Toast('活动已结束')
  }

  // 获取邀请小卡片
  const res = await ajaxHttp.$get('/api/ranking2024/supporter_share')
  let imageUrl = 'https://static.mingchu.co/webapp/index2024/minishare/index_award.png'
  if (res.code === 1) {
    imageUrl = res.data.share_image
  }

  const link = encodeURIComponent(`${config.webapplink}/2024mc/index`)

  // 唤起好友列表 分享小程序卡片 注册
  utils.shareWechat(`{
    "shareSDKPlatformType":"22", 
    "share_plant":"2", 
    "shareContentType":"2", 
    "share_miniProgram_url":"subpages/index2024/award/main?inviter_code=${data.uid}&referrer=share_wx", 
    "share_title":"我正在参与「名厨指数」有奖助力，来助我一臂之力吧！",
    "share_desc":"${shareData.value.share_desc}",
    "share_img":"${imageUrl}", 
    "share_link":"${link}",  
    "share_desc_Sinaweibo":""
    }`
  ).then(res => {
    // 埋点
    sensors.track('MCINDEX2024_award_invite', {
      MCINDEX_title: 'award',
      from: '2024指数_有奖助力页面_邀请好友参与', 
      PlatformType: platformType(),
    })
  })
}

// 去完成
const goToComplete = (item) => {
  const { type, status } = item
  let trackInfo = {
    key: '',
    title: '',
    from: ''
  }

  if ([0, 3, 4].includes(+status)) {
    return Toast(+status === 0 ? '活动暂未开始' : (+status === 3 ? '活动已结束' : '明日再来'))
  } 

  // 分享
  if (type === 'share') {
    goShare()
    return
  }

  // 邀请用户注册
  if (type === 'invitation') {
    goToInvite()
    return
  }

  // 签到
  if (type === 'check_in') {
    trackInfo = {
      key: 'MCINDEX2024_award_signin',
      from: '2024指数_有奖助力页面_每日活动签到'
    }
  }

  // 收藏/关注
  if (type === 'follow') {
    trackInfo = {
      key: 'MCINDEX2024_award_collect',
      from: '2024指数_有奖助力页面_收藏关注'
    }
  }

  // 票选阶段 投票
  if (type === 'share_vote') {
    trackInfo = {
      key: 'MCINDEX2024_award_vote',
      from: '2024指数_有奖助力页面_票选阶段投票'
    }
  }

  // 为xx拉票
  if (type === 'vote') {
    trackInfo = {
      key: 'MCINDEX2024_award_setvote',
      from: '2024指数_有奖助力页面_票选阶段分享拉票'
    }
  }

  // 埋点
  sensors.track(trackInfo.key, {
    MCINDEX_title: 'award',
    from: trackInfo.from,
    PlatformType: platformType()
  })

  // 页面跳转
  router.push({ path: `/2024mc/index` })
}

onMounted(async () => {
  sensors.track('MCINDEX2024_award_visit', {
    MCINDEX_title: 'award',
    from: '2024指数_有奖助力页面访问量',
    PlatformType: platformType()
  })

  getData()
  // window.addEventListener('scroll', handleScroll)

  if (data.isGteatChefbrowser) {
    data.tipShow = false
  } else if (data.isMini) {
    data.tipShow = false
  } else {
    data.tipShow = true
  }
  window.scroll(0, 0)
  // 非名厨浏览器和小程序就隐藏
  const minires = utils.getQueryVariable('token') // 判断是不是在小程序内，隐藏顶部拉起 app 的条
  if (minires) { data.tipShow = false }
  const appres = await utils.getAuth() // 判断是否在app内，隐藏顶部app提示条
  if (appres !== 0) { 
    data.tipShow = false 
  }
})

onUnmounted(() => {
  // window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.user-info {
  background-color: #1c1c1e;
  min-height: rem(120);
  padding: rem(20) rem(20);
  color: #fff;
  background-image: url('https://static.mingchu.co/webapp/index2024/award-bg.png');
  background-size: contain;
  background-repeat: no-repeat;

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: rem(10);
    padding-bottom: rem(16);
    border-bottom: rem(1) solid rgba(255, 255, 255, .1);
  }
  .user-avatar {
    display: flex;
    align-items: center;
  }
  .avatar {
    width: rem(52);
    height: rem(52);
    border-radius: 50%;
    border: rem(1) solid #E5E5E5;
    margin-right: rem(8);
  }
  .invite_btn {
    height: rem(28);
    line-height: rem(28);
    color: #C99700;
    background-color: #fff;
    border-radius: rem(28);
    padding: 0 rem(12);
    font-weight: 500;

    &.disabled {
      color: #999;
      background-color: #F0EFEF;
    }
  }
  .name {
    font-size: rem(16);
    font-weight: 500;
  }
  .job {
    font-size: rem(12);
    font-weight: 400;
  }
  .rule-text {
    color: #C99700;
    display: inline-block;
  }
  .values {
    display: flex;
    justify-content: space-between;
    font-size: rem(14);
    margin-bottom: rem(14);

    .label {
      opacity: .6;
    }

    .value {
      color: #C99700;
      opacity: 1;
      font-size: rem(16);
      font-weight: 500;
    }
  }
}
.helping-content {
  margin-top: rem(-8);
  height: 82vh;
  padding-bottom: rem(60);

  .van-tabs {
    border-radius: rem(8) rem(8) 0 0;
    overflow: hidden;
    background: #F9F8F8;
    padding-top: rem(10);
  }
  :deep(.van-tabs__nav) {
    padding: 0 rem(16);
    background-color: #F9F8F8;
  }
  :deep(.van-tabs__wrap) {
    padding: 0 rem(6);
  }
  :deep(.van-tab) {
    border-bottom: rem(1) solid #ccc;
    color: #333333;
    font-size: rem(16);
    font-weight: 400;
  }
  :deep(.van-tab--active) {
    color: #C99700;
    font-weight: 500;
  }
  :deep(.van-tabs__line) {
    bottom: 0;
    width: 46%;
    background: #C99700;
    border-radius: 0;
  }

  .helping-task,
  .rank-list {
    padding: 0 rem(20);
    height: calc(100vh - rem(54) - rem(120));
    overflow-y: auto;
  }

  .task-list {
    border-bottom: rem(.5) solid #CCCCCC;
    padding: rem(12) 0;
    display: flex;
    justify-content: space-between;

    .task_name {
      color: #181818;
      font-size: rem(16);
      font-weight: 500;
    }
    .explain {
      color: #666;
      font-size: rem(12);
      font-weight: 400;
    }
    .task_btn {
      font-size: rem(12); 
      color: #C99700; 
      background-color: #F4EACC; 
      border-radius: rem(48); 
      padding: 0 rem(18);
      height: rem(30);
      line-height: rem(30);
      min-width: rem(50);
      text-align: center;
      margin: auto 0 auto rem(12);
      font-weight: 500;

      &.is-gray {
        background-color: #F0EFEF;
        color: #999;
      }
    }
  }

  .rank-list {
    padding: 0 rem(20);
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: rem(14) 0;
    }
    .header-item,
    .body-item {
      text-align: left;
      font-size: rem(14);
      font-weight: 500;
      color: #333333;
      line-height: rem(30);
    }

    .header-item {
      color: #828282;
      &:first-child {
        width: rem(30);
        margin-right: rem(40);
      }
      &:nth-child(2) {
        text-align: left;
        flex: 1;
      }
      &:last-child {
        text-align: right;
        width: rem(80);
      }
    }

    .body-item {
      display: flex;
      justify-content: space-between;
      color: #333;
      font-size: rem(16);
      font-weight: 500;
      margin-bottom: rem(14);

      .rank-index {
        width: rem(28);
        height: rem(25);
        color: #999;
        margin-right: rem(40);
        text-align: center;
      }

      .rank_1,
      .rank_2,
      .rank_3 {
        background-image: url('https://static.mingchu.co/webapp/index2024/rank_y.png');
        background-size: cover;
        color: #fff;
        line-height: rem(20);
        margin-top: rem(4);
      }
      .rank_2 {
        background-image: url('https://static.mingchu.co/webapp/index2024/rank_r.png')
      }
      .rank_3 {
        background-image: url('https://static.mingchu.co/webapp/index2024/rank_b.png')
      }

      .user-id {
        display: flex;
        align-items: center;
        flex: 1;

        span {
          vertical-align: top;
        }
      }

      .help-value {
        text-align: right;
        width: rem(80);
      }
    }
    .user-avatar {
      width: rem(28);
      height: rem(28);
      border-radius: 50%;
      border: rem(1) solid #CCCCCC;
      margin-right: rem(4);
    }
  }
}
.award-gain {
  background-color: #C9A128;
  border-radius: rem(8);
  padding: rem(10) rem(16);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FAF5E6;
  margin-top: rem(10);

  .award-ranking {
    font-weight: 500;
    font-size: rem(14);
    color: #fff;
  }
  .prize {
    font-size: rem(14);
    color: #FAF5E6;
  }
}
:deep(.van-popup.task-explain-wrap) {
  padding: rem(20);
  color: #333;

  .title {
    font-size: rem(24);
    font-weight: 500;
    text-align: center;
    margin-bottom: rem(8);
  }
  .body {
    font-size: rem(14);
    line-height: rem(30);
    width: rem(290);

    p {
      position: relative;
      margin-left: rem(12);

      &:before {
        content: '';
        width: rem(5);
        height: rem(5);
        border-radius: 50%;
        background-color: #333;
        position: absolute;
        left: rem(-10);
        top: rem(13);
      }
    }
  }
  .time {
    font-size: 14px;
    line-height: rem(32);
    margin: rem(8) 0  rem(18);
    font-weight: 300;

    .label {
      font-weight: 600;
    }
  }
  .iknow-btn {
    height: rem(48);
    line-height: rem(48);
    text-align: center;
    color: #fff;
    background-color: #C99700;
    border-radius: rem(2);
    font-size: rem(16);
    font-weight: 500;
  }
}
</style>